export const adminMenu = [
  {
    title: "Dashboard",
    url: "/dashboard",
    icon: "pi pi-th-large"
  },
  {
    title: "Admin List",
    url: "/admin",
    icon: "pi pi-user"
  },

  {
    title: "Authority",
    url: "/authority",
    icon: "pi pi-home"
  },
  {
    title: "Settings",
    url: "#",
    icon: "pi pi-cog",
    submenu: [
      {
        title: "Housing Association",
        url: "/housingAssociationlist",
        icon: "pi pi-building"
      }
      // {
      //   title: "Templates",
      //   url: "/template",
      //   icon: "pi pi-file"
      // }
    ]
  }
];
